import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "site",
    "visit",
    "associationsInput",
    "visitsSelected",
    "sitesSelected",
    "siteSearchInput",
    "visitSearchInput",
  ]
  static classes = ["hidden"]

  connect() {
    this.searchVisitsDebounced = debounce(this.searchVisits.bind(this), 300, false)
    this.searchSitesDebounced = debounce(this.searchSites.bind(this), 300, false)
    this.visitSelects = new Selects()
    this.siteSelects = new Selects()
  }

  whichSelects(type) {
    return type === "visit" ? this.visitSelects : this.siteSelects
  }

  searchVisits(event) {
    this.searchElements("visit", event.target.value, this.visitTargets)
  }

  searchSites(event) {
    this.searchElements("site", event.target.value, this.siteTargets)
  }

  searchElements(type, term, elements) {
    for(const element of elements) {
      const name = element.dataset.name
      if (name.toLowerCase().includes(term.toLowerCase())) {
        if (!this.whichSelects(type).collection.map(selected => selected.name).includes(name)) {
          element.classList.remove(this.hiddenClass)
        }
      } else {
        element.classList.add(this.hiddenClass)
      }
    }
  }

  select(event) {
    const selectedData = event.currentTarget.dataset
    if (selectedData.localId === "0") {
      this.selectAll(selectedData.type)
    } else {
      this.addSelected(event, selectedData)
    }
    this.resetSearches()
  }

  resetSearches() {
    const dummyEvent = { target: { value: "" } }
    this.siteSearchInputTarget.value = ""
    this.searchSites(dummyEvent)
    this.visitSearchInputTarget.value = ""
    this.searchVisits(dummyEvent)
  }

  selectAll(type) {
    const selectables = type === "site" ? this.siteTargets : this.visitTargets
    this.whichSelects(type).setAll(
      selectables
        .filter((selected) => selected.dataset.localId !== "0")
        .map((selected) => selected.dataset)
    )
    this.render()
  }

  addSelected(event, selectedData) {
    event.currentTarget.classList.add(this.hiddenClass)
    this.whichSelects(selectedData.type).add(selectedData)
    this.render()
  }

  render() {
    this.visitsSelectedTarget.textContent = this.visitSelects.name
    this.sitesSelectedTarget.textContent = this.siteSelects.name
    const selectParams = []
    for (const visit of this.visitSelects.collection) {
      for (const site of this.siteSelects.collection) {
        selectParams.push({
          schedule_name: visit.name,
          site_name: site.name,
          trial_schedule_local_id: visit.localId,
          trial_site_local_id: site.localId
        })
      }
    }
    this.associationsInputTarget.value = JSON.stringify(selectParams)
  }
}

class Selects {
  constructor() {
    this.collection = []
  }

  get isEmpty() {
    return this.collection.length === 0
  }

  get name () {
    return this.collection.map(item => item.name).join(', ')
  }

  add(data) {
    this.collection.push(data)
  }

  setAll(data) {
    if (!Array.isArray(data)) {
      throw new Error('setAll expects an array')
    }
    this.collection = data
  }
}
